import { defineStore } from "pinia";
import { privateBoaHttp } from "@/boa-api-client";
import type { Tag } from "best-of-awards-api";

type State = {
  tagsLoaded: boolean;
  tagGroupsLoaded: boolean;
  tagGroups: any[];
  tags: Array<Tag>;
};

export default defineStore("tags", {
  state: (): State => ({
    tagsLoaded: false,
    tagGroupsLoaded: false,
    tagGroups: [],
    tags: [],
  }),
  getters: {
    contactTags: (state) =>
      state.tags.filter((t) => t.groups.some((g) => g.name === "Contact")),
    loaded: (state) => state.tagsLoaded && state.tagGroupsLoaded,
  },
  actions: {
    async getTags() {
      try {
        const tags = await privateBoaHttp("tags").json<Array<Tag>>();
        this.tags = tags;
        this.tagsLoaded = true;
      } catch (error) {
        console.error(error);
      }
    },
    async getTagGroups() {
      try {
        const groups: any[] = await privateBoaHttp("tag-groups").json();
        this.tagGroups = groups;
        this.tagGroupsLoaded = true;
      } catch (error) {
        console.error(error);
      }
    },
    async updateTag(updatedTag: any) {
      try {
        const response = await privateBoaHttp
          .post(`tags/${updatedTag.id}`, { json: updatedTag })
          .json();
        return response;
      } catch (error) {
        console.error((error as any).message);
      }
    },
    async createTag(newTag: any) {
      try {
        const response = await privateBoaHttp
          .put("tags", { json: newTag })
          .json();
        return response;
      } catch (error) {
        console.error((error as any).message);
      }
    },
    clear() {
      this.$reset();
    },
  },
});
